import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";

const BASE_URL = "/become-partner";

export const BecomePartnerAPI = Object.freeze({
  get: createAsyncThunk(
    "get/become-partner",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, {
          params,
        });
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  delete: createAsyncThunk(
    "delete/become-partner",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(`${BASE_URL}/${id}`);
        return response.data;
      } catch (err) {
        return rejectWithValue("Something went wrong");
      }
    }
  ),
});
